<template>
    <div class="main-outfit-container">
        <div
            class="generated-outfit-container"
            ref="swipeyBoy"
            id="generated-outfit-container"
            v-show="!noOutfitsForTheseFilters"
        >
            <transition
                name="fade"
                mode="out-in"
                :duration="{ enter: 600, leave: 450 }"
            >
                <div
                    v-show="showOutfitCard"
                    class="outfit-items-container swipeable"
                    :class="outfitContainerClass"
                    key="1"
                    :style="outfitContainerStyle"
                    ref="swipeableEl"
                >
                    <outfit-card
                        :outfit="outfitCurrent"
                        :handleProductClk="handleVisitProduct"
                        :swapProductClk="swapProductCb"
                        ref="outfitCard"
                    />
                    <div
                        class="outfit-swipe-box"
                        :style="outfitSwipeBoxStyle"
                        v-show="swipeScore !== 0"
                    >
                        <h3>{{ outfitSwipeBoxText }}</h3>
                    </div>
                </div>
            </transition>
            <transition
                name="fade"
                mode="out-in"
                :duration="{ enter: 600, leave: 450 }"
            >
                <loader v-show="!showOutfitCard" message="Loading outfit" />
            </transition>
            <div class="outfit-card-placeholder"></div>
        </div>
        <div
            class="no-outfits-match-container"
            v-show="noOutfitsForTheseFilters"
        >
            <h1 class="no-outfits-match">No Outfits Match These Filters</h1>
        </div>
    </div>
</template>

<script>
import Mixins from "../../mixins/mixins";
import $ from "webpack-zepto";
import { _ } from "vue-underscore";
import Loader from "../common/loader.vue";
import HeartUnfilled from "../common/heart-unfilled.vue";
import OutfitCard from "./outfit-card.vue";
import { OUTFIT_TYPES } from "../../config";
import interact from "interactjs";

export default {
    mixins: [Mixins],
    components: { Loader, HeartUnfilled, OutfitCard },
    props: {
        outfitCurrent: Object,
        noOutfitsForTheseFilters: Boolean,
        saveOutfit: Function,
        rejectOutfit: Function,
        visitProduct: {
            type: Boolean,
            default: true,
        },
        swapProductCb: Function,
    },
    computed: {
        showOutfitCard() {
            return (
                this.isOutfitAvailable && !this.isSwiping && this.outfitLoaded
            );
        },
        isOutfitAvailable() {
            return this.outfitCurrent?.products?.length > 0;
        },
        outfitContainerStyle() {
            return {
                transform: `translateX(${this.position.x}px) rotate(${this.position.rotate}deg)`,
            };
        },
        outfitSwipeBoxStyle() {
            const opacity = this.swipeScore * this.swipeBoxOpacity;
            return {
                opacity: opacity > 0.85 ? 0.85 : opacity,
            };
        },
        outfitContainerClass() {
            const outfitContainerClass = "outfit-items-container";
            return {
                [`${outfitContainerClass}--saved`]: this.swipeScore === 1,
                [`${outfitContainerClass}--rejected`]: this.swipeScore === -1,
                [`${outfitContainerClass}--finish`]: this.finishClass,
            };
        },
        outfitSwipeBoxText() {
            switch (this.swipeScore) {
                case 0:
                    return "";
                case 1:
                    return "like";
                case -1:
                    return "reject";
            }
        },
        swipeScore() {
            if (this.position.x === 0) return 0;

            return this.position.x > 0 ? 1 : -1;
        },
        swipeThreshold() {
            return window.innerWidth * 0.05;
        },
        finishPosition() {
            return window.innerWidth * 1.5;
        },
        scoreCb() {
            switch (this.swipeScore) {
                case 1:
                    return this.saveOutfit;
                case -1:
                    return this.rejectOutfit;
            }
        },
        shouldScore() {
            return this.swipeScore * this.position.x >= this.swipeThreshold;
        },
    },
    data() {
        return {
            finishRotate: 35,
            successRejectDelay: 200,

            //Swipe outer box
            position: {
                x: 0,
                rotate: 0,
            },
            swipeBoxOpacity: 0,
            finishClass: false,

            isSwiping: false,

            outfitLoaded: false,
        };
    },
    methods: {
        handleVisitProduct(product, outfit) {
            if (this.visitProduct === true) {
                this.$helpers.visitProduct(this.$router, product, {
                    outfitId: outfit.outfit_id,
                    outfitType: OUTFIT_TYPES.GENERATED,
                });
            }
        },
        resetDragProperties() {
            this.position = {
                x: 0,
                rotate: 0,
            };
            this.swipeBoxOpacity = 0;
            setTimeout(() => {
                this.finishClass = false;
                this.isSwiping = false;
            }, 400);
        },
        swipeFinished() {
            return this.prepareAndAnimate()
                .catch((err) => {
                    console.error(err);
                })
                .finally(this.resetDragProperties);
        },
        prepareAndAnimate() {
            this.finishClass = true;

            if (!this.shouldScore) return Promise.resolve(false);

            const score = this.swipeScore;
            this.position.x = score * this.finishPosition;
            this.position.rotate = score * this.finishRotate;

            return this.delay(() => {
                this.isSwiping = true;
                return this.scoreCb();
            }, this.successRejectDelay);
        },
    },
    mounted() {
        interact(".swipeable").draggable({
            listeners: {
                start: (event) => {},
                move: (event) => {
                    this.position.x += event.dx;
                    this.position.rotate += event.dx / 10;
                    this.swipeBoxOpacity += event.dx / 200;
                },
                end: this.swipeFinished,
            },
            startAxis: "x",
            lockAxis: "x",
        });
        this.$watch(
            () => this.$refs.outfitCard.completeLoaded,
            (status) => {
                this.outfitLoaded = status;
            }
        );
    },
    beforeDestroy() {
        this.resetDragProperties();
        if (this.$refs.swipeableEl) interact(this.$refs.swipeableEl).unset();
    },
};
</script>

<style lang="scss" scoped>
$outerPadding: 13px;

.generated-outfit-container {
    width: 100vw;
    padding: $outerPadding;
    position: relative;

    .outfit-items-container {
        z-index: 1;
        transform: translateX(0%) rotate(0deg);
        &--saved {
            z-index: 100;
            .outfit-swipe-box {
                background-color: #f2c0de;
            }
        }
        &--rejected {
            z-index: 100;
            .outfit-swipe-box {
                background-color: black;
            }
        }
        &--finish {
            transition: transform 0.4s;
        }
        .outfit-swipe-box {
            border-radius: 20px;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0.85;
            font-size: 46px;
            font-weight: 900;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            text-transform: uppercase;
            &--like {
                background-color: #f2c0de;
            }
            &--reject {
                background-color: black;
            }
        }
    }
    .outfit-card-placeholder {
        border-radius: 20px;
        border: 1px solid #f0f0f0;
        position: absolute;
        top: $outerPadding;
        left: $outerPadding;
        height: calc(100% - #{$outerPadding * 2});
        width: calc(100% - #{$outerPadding * 2});
    }
}

.swipeable {
    touch-action: none;
    user-select: none;
}
</style>
